module.exports = __webpack_public_path__ + "static/media/service_programming_language_icons_mo.a9bb1716.png";